export type ActionResult =
  | { ok: true; message?: string }
  | { ok: false; message: string };

export const initialActionResult: ActionResult = { ok: true };
